/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Duplicate_SuccessInputs */



/**
* | output |
* | --- |
* | "Event group has been duplicated." |
*
* @param {Event_Group_Options_Duplicate_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_duplicate_success = /** @type {((inputs?: Event_Group_Options_Duplicate_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Duplicate_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe d'événements a été dupliqué.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisgruppe wurde dupliziert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo di eventi è stato duplicato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа событий продублирована.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El grupo de eventos ha sido duplicado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组已重复。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント グループが複製されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह की प्रतिलिपि बन गई है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo de eventos foi duplicado.")
	return /** @type {LocalizedString} */ ("Event group has been duplicated.")
});